module.exports = __webpack_public_path__ + "img/2xBAR.6585bc55.png";